import React from "react";
import { FaChartArea } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa";
import { FaChartBar } from "react-icons/fa";
import { FaChartPie } from "react-icons/fa";
import { GiRadarCrossSection } from "react-icons/gi";
import "./css/CustomToolTip.css";

export const AreaCustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="CustomTooltip">
        <span className="CustomTooltipLabel">{label}</span>
        {payload.map((ele, index) => (
          <>
            <small
              style={{
                padding: "5px",
              }}
              key={index}
            >
              <FaChartArea color={ele.color} /> {ele.name} : <b>{ele.value}</b>
            </small>
          </>
        ))}
      </div>
    );
  }

  return null;
};

export const LineCustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="CustomTooltip">
        <span className="CustomTooltipLabel">{label}</span>
        {payload.map((ele, index) => (
          <>
            <small
              style={{
                padding: "5px",
              }}
              key={index}
            >
              <FaChartLine color={ele.color} /> {ele.name} : <b>{ele.value}</b>
            </small>
          </>
        ))}
      </div>
    );
  }

  return null;
};

export const BarCustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="CustomTooltip">
        <span className="CustomTooltipLabel">{label}</span>
        {payload.map((ele, index) => (
          <>
            <small
              style={{
                padding: "5px",
              }}
              key={index}
            >
              <FaChartBar color={ele.color} /> {ele.name} : <b>{ele.value}</b>
            </small>
          </>
        ))}
      </div>
    );
  }

  return null;
};

export const PieCustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const keyName = payload[0].dataKey;
    const labelName = Object.values(
      Object.values(Object.values(payload[0])[2])[0]
    )[0];
    //const payloadDict = Object.fromEntries(Object.entries(Object.values(Object.values(payload[0])[2])[0]).slice(1));
    const payloadDict = Object.values(Object.values(payload[0])[2])[0];
    const keyValue = payloadDict[keyName];

    //const lvl3 = Object.values(Object.values(Object.values(payload[0])[2])[0]).slice(1)
    //alert(JSON.stringify(lvl3));

    /*alert(JSON.stringify(payloadDict));
    for (const key in payloadDict) {
      if (payloadDict.hasOwnProperty(key)) {
        const value = payloadDict[key];
        alert(`Key: ${key}, Value: ${value}`);
      }
    } */

    return (
      <div className="CustomTooltip">
        <span className="CustomTooltipLabel">
          <FaChartPie /> {labelName}
        </span>
        <small
          style={{
            padding: "5px",
          }}
        >
          {keyName} : <b>{keyValue}</b>
        </small>
      </div>
    );
  }

  return null;
};

export const RadarCustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    //alert(JSON.stringify(payload))
    const keyName = payload[0].dataKey;
    const payloadDict = payload[0].payload;

    const labelName = Object.values(payloadDict)[0];
    //const payloadDict = Object.values(Object.values(payload[0])[2])[0];
    const keyValue = payloadDict[keyName];
    //alert(JSON.stringify(labelName))
    //alert(keyName)
    //alert(keyValue)
    return (
      <div className="CustomTooltip">
        <span className="CustomTooltipLabel">
          <GiRadarCrossSection /> {labelName}
        </span>
        <small
          style={{
            padding: "5px",
          }}
        >
          {keyName} : <b>{keyValue}</b>
        </small>
      </div>
    );
  }

  return null;
};

export const ModifyFormatter = (value, name, props, label) => {
  const nameJSX = (
    <div className="CustomTooltip">
      <span>
        <b>{label}</b>

        <br />
        <small
          style={{
            padding: "5px",
          }}
        >
          <FaChartArea color={props.color} /> {name} : <b>{value} </b>
        </small>
      </span>
    </div>
  );
  return [nameJSX];
};
const modifyFormatterOld = (value, name, props) => {
  const nameJSX = (
    <span>
      <span
        style={{
          display: "flex",
          marginRight: "5px",
          borderRadius: "10px",
          width: "10px",
          height: "15px",
          backgroundColor: props.color,
          fontSize: "8px",
        }}
      ></span>
      {name} : {value}
    </span>
  );
  return [nameJSX];
};
